import { ReactComponent as QobuzColorLight } from 'fym-shared/src/music-services/assets/images/qobuz-color-light.svg';
import { ReactComponent as QobuzColorDark } from 'fym-shared/src/music-services/assets/images/qobuz-color-dark.svg';
import { ReactComponent as QobuzColorLightPadding } from 'fym-shared/src/music-services/assets/images/qobuz-color-light-padding.svg';
import { ReactComponent as QobuzColorDarkPadding } from 'fym-shared/src/music-services/assets/images/qobuz-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const qobuzImages: MusicServiceImages = {
  logoColor: {
    light: QobuzColorLight,
    dark: QobuzColorDark,
  },
  logoColorPadding: {
    light: QobuzColorLightPadding,
    dark: QobuzColorDarkPadding,
  },
};
